import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "construction-worker-edit" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Bedrijf / Company", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Bedrijf (contractpartij) / Company (contracting party)", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Medewerker is ingehuurd door een contractpartij "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Bedrijfsnaam medewerker (niet de naam van de contractpartij) "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Voornaam / Firstname", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Achternaam / Lastname", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Bouwplaatsmedewerker in dienst", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Adres / Address", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Postcode / Zipcode", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Plaats / City", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Geboortedatum / Date of birth", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Nationaliteit / Nationality", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "ID - Document type", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "ID - Land van uitgifte / Country of issue", -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "ID - BSN / Personal identification number", -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, "ID - Documentnummer / Document number", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "ID - Geldig tot / Date of expiry", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, "Verblijfsvergunning / Residence permit", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", null, "Nederlandse werkvergunning / Dutch work permit", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", null, "Werkvergunningsnummer / Work permit number", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", null, "Werkvergunning geldig tot / Work permit date of expiry", -1)
const _hoisted_28 = {
  key: 0,
  class: "error"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", null, "VCA gecertificeerd / Certified", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", null, "VCA - Geldig tot / Date of expiry", -1)
const _hoisted_31 = {
  key: 0,
  class: "error"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", null, "In bezit van GPI / In possession of GPI", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, "GPI - Geldig tot / Date of expiry", -1)
const _hoisted_34 = {
  key: 0,
  class: "error"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", null, "In bezit van PU certificaat / In possession of PU certificate", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", null, "PU - Geldig tot / Date of expiry", -1)
const _hoisted_37 = {
  key: 0,
  class: "error"
}

import { computed, onMounted, ref, watch } from 'vue'
import axios from 'axios'
import { ConstructionWorker } from '@/types/constructionWorker'
import { useRoute, useRouter } from 'vue-router'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons-vue'
import dayjs, { Dayjs } from 'dayjs'
import { notification } from 'ant-design-vue'
import { authStore } from '@/stores/auth'
import PageTitleBar from '@/components/PageTitleBar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConstructionWorkerEdit',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const loading = ref(false)
const companies = ref([])
const saving = ref(false)
let companyTimer = 0

const disabledDatesOfBirth = (current: Dayjs) => current > dayjs().subtract(16, 'year')
const disabledDatesInPast = (current: Dayjs) => current < dayjs().startOf('day')

const EERMember = computed(() => {
  return constructionWorker.value.EERMember
})

const requiredFieldsCompleted = computed(() => {
  let rfc = false
  const minRequired = !!(
    constructionWorker.value.company_id &&
    constructionWorker.value.firstname &&
    constructionWorker.value.lastname &&
    constructionWorker.value.address &&
    constructionWorker.value.zipcode &&
    constructionWorker.value.city &&
    constructionWorker.value.date_of_birth &&
    constructionWorker.value.nationality_id &&
    constructionWorker.value.document_type &&
    constructionWorker.value.document_country_id &&
    constructionWorker.value.personal_identification_number &&
    constructionWorker.value.document_number &&
    constructionWorker.value.document_expiry_date &&
    (constructionWorker.value.vca_certified === 0 ? true : (!!(constructionWorker.value.vca_expiry_date))) &&
    (constructionWorker.value.gpi_certified === 0 ? true : (!!(constructionWorker.value.gpi_expiry_date))) &&
    (constructionWorker.value.pu_certified === 0 ? true : (!!(constructionWorker.value.pu_expiry_date)))
  )

  if (EERMember.value) {
    rfc = minRequired
  } else {
    rfc = !!(
      minRequired &&
      constructionWorker.value.residence_permit &&
      constructionWorker.value.work_permit &&
      constructionWorker.value.work_permit_number &&
      constructionWorker.value.work_permit_expiry_date
    )
  }

  return rfc
})

const constructionWorker = ref<ConstructionWorker>({
  company_id: null,
  company: null,
  is_subcontractor: false,
  subcontractor_company_name: null,
  firstname: null,
  lastname: null,
  street: null,
  housenumber: null,
  address: null,
  zipcode: null,
  city: null,
  date_of_birth: null,
  nationality_id: 92,
  nationality: null,
  document_type: 1,
  document_country_id: 92,
  country: null,
  EERMember: null,
  personal_identification_number: null,
  document_number: null,
  document_expiry_date: null,
  residence_permit: null,
  work_permit: null,
  work_permit_number: null,
  work_permit_expiry_date: null,
  vca_certified: 0,
  vca_expiry_date: null,
  gpi_certified: 0,
  gpi_expiry_date: null,
  pu_certified: 0,
  pu_expiry_date: null,
  portraitPhoto: [],
  idFront: [],
  idBack: [],
  permitFront: [],
  permitBack: [],
  signature: [],
  denied: {
    is_denied: false,
    denied_by_user: null,
    denied_at: null,
    reason: null
  }
})

onMounted(() => {
  getConstructionWorker()
})

watch(() => constructionWorker.value.company, () => {
  if (constructionWorker.value.company && authStore().isInternal) {
    searchCompanies(constructionWorker.value.company.name)
  }
}, { deep: true })

function getConstructionWorker () : void {
  loading.value = true
  axios.get(process.env.VUE_APP_API_URL + '/constructionWorkers/' + route.params.constructionWorkerId).then((r) => {
    constructionWorker.value = r.data.data
    constructionWorker.value.date_of_birth = constructionWorker.value.date_of_birth ? dayjs(r.data.data.date_of_birth) : null
    constructionWorker.value.document_expiry_date = constructionWorker.value.document_expiry_date ? dayjs(r.data.data.document_expiry_date) : null
    constructionWorker.value.work_permit_expiry_date = constructionWorker.value.work_permit_expiry_date ? dayjs(r.data.data.work_permit_expiry_date) : null
    constructionWorker.value.vca_expiry_date = constructionWorker.value.vca_expiry_date ? dayjs(r.data.data.vca_expiry_date) : null
    constructionWorker.value.gpi_expiry_date = constructionWorker.value.gpi_expiry_date ? dayjs(r.data.data.gpi_expiry_date) : null
    constructionWorker.value.pu_expiry_date = constructionWorker.value.pu_expiry_date ? dayjs(r.data.data.pu_expiry_date) : null
    constructionWorker.value.is_subcontractor = !!r.data.data.subcontractor_company_name
  }).catch(() => {
    notification.error({ message: 'Fout bij ophalen van medewerker!', description: 'Er is iets mis gegaan. Probeer het later nog een keer.' })
  }).finally(() => {
    loading.value = false
  })
}

function updateConstructionWorker () : void {
  if (!constructionWorker.value.is_subcontractor) {
    constructionWorker.value.subcontractor_company_name = null
  }

  const data = {
    ...constructionWorker.value,
    date_of_birth: constructionWorker.value.date_of_birth ? dayjs(constructionWorker.value.date_of_birth).format('YYYY-MM-DD HH:mm:ss') : null,
    document_expiry_date: constructionWorker.value.document_expiry_date ? dayjs(constructionWorker.value.document_expiry_date).format('YYYY-MM-DD HH:mm:ss') : null,
    work_permit_expiry_date: constructionWorker.value.work_permit_expiry_date ? dayjs(constructionWorker.value.work_permit_expiry_date).format('YYYY-MM-DD HH:mm:ss') : null,
    vca_expiry_date: constructionWorker.value.vca_expiry_date ? dayjs(constructionWorker.value.vca_expiry_date).format('YYYY-MM-DD HH:mm:ss') : null,
    gpi_expiry_date: constructionWorker.value.gpi_expiry_date ? dayjs(constructionWorker.value.gpi_expiry_date).format('YYYY-MM-DD HH:mm:ss') : null,
    pu_expiry_date: constructionWorker.value.pu_expiry_date ? dayjs(constructionWorker.value.pu_expiry_date).format('YYYY-MM-DD HH:mm:ss') : null
  }

  axios.patch(process.env.VUE_APP_API_URL + '/constructionWorkers/' + route.params.constructionWorkerId, data).then((r) => {
    notification.success({
      message: 'Medewerker succesvol bijgewerkt.',
      description: 'De medewerker is succesvol bijgewerkt.',
      duration: 5
    })
    constructionWorker.value = r.data.data
    constructionWorker.value.date_of_birth = constructionWorker.value.date_of_birth ? dayjs(r.data.data.date_of_birth) : null
    constructionWorker.value.document_expiry_date = constructionWorker.value.document_expiry_date ? dayjs(r.data.data.document_expiry_date) : null
    constructionWorker.value.work_permit_expiry_date = constructionWorker.value.work_permit_expiry_date ? dayjs(r.data.data.work_permit_expiry_date) : null
    constructionWorker.value.vca_expiry_date = constructionWorker.value.vca_expiry_date ? dayjs(r.data.data.vca_expiry_date) : null
    constructionWorker.value.gpi_expiry_date = constructionWorker.value.gpi_expiry_date ? dayjs(r.data.data.gpi_expiry_date) : null
    constructionWorker.value.pu_expiry_date = constructionWorker.value.pu_expiry_date ? dayjs(r.data.data.pu_expiry_date) : null
  }).catch(() => {
    notification.error({ message: 'Fout tijdens opslaan van bouwplaatsmedewerker!', description: 'Er is iets mis gegaan. Probeer het later nog een keer.', duration: 0 })
  })
}

function searchCompanies (val:string) : void {
  if (val.length >= 3) {
    clearTimeout(companyTimer)
    companyTimer = setTimeout(() => {
      axios.get(process.env.VUE_APP_API_URL + '/companies?filter[search]=' + val).then((res) => {
        companies.value = res.data.data
      })
    }, 500)
  } else {
    companies.value = []
  }
}

function enableAccess () : void {
  saving.value = true
  axios.post(process.env.VUE_APP_API_URL + '/constructionWorkers/' + constructionWorker.value.id + '/allow').then(() => {
    getConstructionWorker()
    notification.success({
      message: 'Toegang succesvol gegeven.',
      description: 'De bouwplaatsmedewerker kan weer geregistreerd worden op een van onze bouwplaatsen.',
      duration: 5
    })
  }).catch(() => {
    notification.error({
      message: 'Fout tijdens geven van toegang aan bouwplaatsmedewerker!',
      description: 'Er is iets mis gegaan. Probeer het later nog een keer.'
    })
  }).finally(() => {
    saving.value = false
  })
}

function vcaChanged () : void {
  if (constructionWorker.value.vca_certified === 0) {
    constructionWorker.value.vca_expiry_date = null
  }
}

function gpiChanged () : void {
  if (constructionWorker.value.gpi_certified === 0) {
    constructionWorker.value.gpi_expiry_date = null
  }
}

function puChanged () : void {
  if (constructionWorker.value.pu_certified === 0) {
    constructionWorker.value.pu_expiry_date = null
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageTitleBar, null, {
      title: _withCtx(() => [
        _createTextVNode("Medewerker bewerken.")
      ]),
      buttons: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'ConstructionWorkers' })))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Terug naar overzicht")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              title: constructionWorker.value.firstname && constructionWorker.value.lastname ? constructionWorker.value.firstname + ' ' + constructionWorker.value.lastname : 'Bouwplaatsmedewerker',
              loading: loading.value
            }, _createSlots({
              default: _withCtx(() => [
                (_unref(authStore)().isInternal)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_2,
                            _createVNode(_component_a_select, {
                              placeholder: "Begin met typen om te zoeken..",
                              "default-active-first-option": false,
                              "filter-option": false,
                              fieldNames: { label: 'name', value: 'id' },
                              options: companies.value,
                              value: constructionWorker.value.company_id,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((constructionWorker.value.company_id) = $event)),
                              onSearch: searchCompanies,
                              "show-search": ""
                            }, null, 8, ["options", "value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_3,
                            _createElementVNode("p", null, _toDisplayString(constructionWorker.value.company ? constructionWorker.value.company.name : ''), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_4,
                        _createVNode(_component_a_radio_group, {
                          "button-style": "solid",
                          value: constructionWorker.value.is_subcontractor,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((constructionWorker.value.is_subcontractor) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CloseOutlined))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CheckOutlined))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (constructionWorker.value.is_subcontractor)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_5,
                            _createVNode(_component_a_input, {
                              type: "text",
                              value: constructionWorker.value.subcontractor_company_name,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((constructionWorker.value.subcontractor_company_name) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_6,
                        (constructionWorker.value.firstname)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(constructionWorker.value.firstname), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        (constructionWorker.value.lastname)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(constructionWorker.value.lastname), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        _createVNode(_component_a_radio_group, {
                          "button-style": "solid",
                          value: constructionWorker.value.active,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((constructionWorker.value.active) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CloseOutlined))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CheckOutlined))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_11,
                        _createVNode(_component_a_input, {
                          type: "text",
                          value: constructionWorker.value.address,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((constructionWorker.value.address) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createVNode(_component_a_input, {
                          type: "text",
                          value: constructionWorker.value.zipcode,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((constructionWorker.value.zipcode) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_13,
                        _createVNode(_component_a_input, {
                          type: "text",
                          value: constructionWorker.value.city,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((constructionWorker.value.city) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_14,
                        _createVNode(_component_a_date_picker, {
                          placeholder: "Selecteer een geboortedatum",
                          format: "DD-MM-YYYY",
                          "disabled-date": disabledDatesOfBirth,
                          value: constructionWorker.value.date_of_birth,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((constructionWorker.value.date_of_birth) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_15,
                        (constructionWorker.value.nationality)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(constructionWorker.value.nationality.nationality), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_17,
                        _createVNode(_component_a_radio_group, {
                          "button-style": "solid",
                          value: constructionWorker.value.document_type,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((constructionWorker.value.document_type) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: 1 }, {
                              default: _withCtx(() => [
                                _createTextVNode("ID-bewijs")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: 2 }, {
                              default: _withCtx(() => [
                                _createTextVNode("Paspoort")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: 3 }, {
                              default: _withCtx(() => [
                                _createTextVNode("Rijbewijs")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_18,
                        (constructionWorker.value.country)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(constructionWorker.value.country.name), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_20,
                        (constructionWorker.value.personal_identification_number)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(constructionWorker.value.personal_identification_number), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_22,
                        _createVNode(_component_a_input, {
                          type: "text",
                          value: constructionWorker.value.document_number,
                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((constructionWorker.value.document_number) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_23,
                        _createVNode(_component_a_date_picker, {
                          format: "DD-MM-YYYY",
                          value: constructionWorker.value.document_expiry_date,
                          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((constructionWorker.value.document_expiry_date) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!_unref(EERMember))
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 3 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_24,
                            _createVNode(_component_a_radio_group, {
                              "button-style": "solid",
                              value: constructionWorker.value.residence_permit,
                              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((constructionWorker.value.residence_permit) = $event)),
                              disabled: true
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_button, { value: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CloseOutlined))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_radio_button, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CheckOutlined))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_unref(EERMember) && constructionWorker.value.residence_permit)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_25,
                            _createVNode(_component_a_radio_group, {
                              "button-style": "solid",
                              value: constructionWorker.value.work_permit,
                              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((constructionWorker.value.work_permit) = $event)),
                              disabled: true
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_button, { value: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CloseOutlined))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_radio_button, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CheckOutlined))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_unref(EERMember) && constructionWorker.value.work_permit)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 5 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_26,
                            _createVNode(_component_a_input, {
                              type: "text",
                              value: constructionWorker.value.work_permit_number,
                              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((constructionWorker.value.work_permit_number) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_unref(EERMember) && constructionWorker.value.work_permit)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_27,
                            _createVNode(_component_a_date_picker, {
                              format: "DD-MM-YYYY",
                              value: constructionWorker.value.work_permit_expiry_date,
                              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((constructionWorker.value.work_permit_expiry_date) = $event))
                            }, null, 8, ["value"]),
                            (constructionWorker.value.work_permit_expiry_date && new Date() > new Date(constructionWorker.value.work_permit_expiry_date))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Werkvergunning verlopen / Work permit expired!"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_29,
                        _createVNode(_component_a_radio_group, {
                          "button-style": "solid",
                          value: constructionWorker.value.vca_certified,
                          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((constructionWorker.value.vca_certified) = $event)),
                          onChange: vcaChanged
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CloseOutlined))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CheckOutlined))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (constructionWorker.value.vca_certified)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 7 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_30,
                            _createVNode(_component_a_date_picker, {
                              format: "DD-MM-YYYY",
                              "disabled-date": disabledDatesInPast,
                              value: constructionWorker.value.vca_expiry_date,
                              "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((constructionWorker.value.vca_expiry_date) = $event))
                            }, null, 8, ["value"]),
                            (constructionWorker.value.vca_expiry_date && new Date() > new Date(constructionWorker.value.vca_expiry_date))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_31, "VCA verlopen / VCA expired!"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_32,
                        _createVNode(_component_a_radio_group, {
                          "button-style": "solid",
                          value: constructionWorker.value.gpi_certified,
                          "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((constructionWorker.value.gpi_certified) = $event)),
                          onChange: gpiChanged
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CloseOutlined))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CheckOutlined))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (constructionWorker.value.gpi_certified)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_33,
                            _createVNode(_component_a_date_picker, {
                              format: "DD-MM-YYYY",
                              "disabled-date": disabledDatesInPast,
                              value: constructionWorker.value.gpi_expiry_date,
                              "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((constructionWorker.value.gpi_expiry_date) = $event))
                            }, null, 8, ["value"]),
                            (constructionWorker.value.gpi_expiry_date && new Date() > new Date(constructionWorker.value.gpi_expiry_date))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_34, "GPI verlopen / GPI expired!"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_35,
                        _createVNode(_component_a_radio_group, {
                          "button-style": "solid",
                          value: constructionWorker.value.pu_certified,
                          "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((constructionWorker.value.pu_certified) = $event)),
                          onChange: puChanged
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CloseOutlined))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CheckOutlined))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (constructionWorker.value.pu_certified)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 9 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_36,
                            _createVNode(_component_a_date_picker, {
                              format: "DD-MM-YYYY",
                              "disabled-date": disabledDatesInPast,
                              value: constructionWorker.value.pu_expiry_date,
                              "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((constructionWorker.value.pu_expiry_date) = $event))
                            }, null, 8, ["value"]),
                            (constructionWorker.value.pu_expiry_date && new Date() > new Date(constructionWorker.value.pu_expiry_date))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_37, "PU verlopen / PU expired!"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          disabled: !_unref(requiredFieldsCompleted),
                          onClick: updateConstructionWorker
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Opslaan")
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, [
              (constructionWorker.value.denied.is_denied)
                ? {
                    name: "extra",
                    fn: _withCtx(() => [
                      _createVNode(_component_a_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            span: 24,
                            class: "text-right"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_popconfirm, {
                                title: "Deze persoon weer toegang geven?",
                                "ok-text": "Ja, toegang geven",
                                "cancel-text": "Annuleren",
                                onConfirm: enableAccess,
                                disabled: saving.value
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Toegang herstellen")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["title", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})